/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationDetailsUpdateRequest
 */
export interface OrganizationDetailsUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDetailsUpdateRequest
     */
    organizationName: string;
}

/**
 * Check if a given object implements the OrganizationDetailsUpdateRequest interface.
 */
export function instanceOfOrganizationDetailsUpdateRequest(value: object): value is OrganizationDetailsUpdateRequest {
    if (!('organizationName' in value) || value['organizationName'] === undefined) return false;
    return true;
}

export function OrganizationDetailsUpdateRequestFromJSON(json: any): OrganizationDetailsUpdateRequest {
    return OrganizationDetailsUpdateRequestFromJSONTyped(json, false);
}

export function OrganizationDetailsUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDetailsUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'organizationName': json['organizationName'],
    };
}

export function OrganizationDetailsUpdateRequestToJSON(value?: OrganizationDetailsUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'organizationName': value['organizationName'],
    };
}

